import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import WarningIconM from '@mui/icons-material/Warning';

import { Box } from '@mui/material';

export const WarningIcon = () => {
  return (
        <Box
            sx={{
                width: 0,
                height: 0,
                borderLeft: '22px solid transparent',
                borderRight: '22px solid transparent',
                borderBottom: '38px solid #000000', 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <WarningIconM
                sx={{
                    marginTop: '40px',
                    fontSize: '50px',
                    color: '#FFC107', 
                }}
            />
        </Box>
  );
}

